import { useLocation } from "react-router-dom"

export function Club(props) {
    const location = useLocation()
    return(
        <div>
            {location.pathname.split("/")[2]}의 동아리 소개 페이지입니다.
        </div>
    )
}